<template>
  <v-card class="mx-4 my-6" :style="cardClass" id="recon-notes">
    <v-card-title class="d-flex justify-space-between"
      >Notes
      <v-card
        class="mt-0 d-flex align-center"
        height="40"
        tile
        width="40"
        color="secondary"
        @click="addNote()"
        id="note-input"
      >
        <v-row>
          <v-spacer />
          <v-col id="add-notes-button">
            <v-icon color="white">mdi-plus</v-icon>
          </v-col>
          <v-spacer />
        </v-row>
      </v-card>
    </v-card-title>
    <v-textarea
      label="Note"
      filled
      required
      class="pa-4"
      v-model="currentNote"
      id="recon-notes-textarea"
    ></v-textarea>
    <div class="d-flex justify-end pb-3 pr-5" style="width:100%;">
      <v-btn
        tile
        color="#D4022A"
        style="color:white;"
        class="d-flex  ma-2"
        @click="clearNote()"
        id="cancel-note"
      >
        <v-icon left dark>mdi-close</v-icon>Cancel</v-btn
      >
      <v-btn
        tile
        color="secondary"
        style="color:white;"
        class="d-flex ma-2"
        @click="addNote()"
        id="save-note"
        ><v-icon left dark>mdi-content-save</v-icon>Save</v-btn
      >
    </div>
    <div v-if="notes.length > 0">
      <div v-for="(note, index) in notes" :key="index">
        <v-text-field
          :label="note.date"
          filled
          readonly
          append-icon="mdi-trash-can"
          @click:append="deleteNote(note.uuid, index)"
          required
          class="pt-1 pr-4 pl-4"
          v-model="note.note"
        ></v-text-field>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import moment from "moment";
import ReconciliationDetailData from '@/mixins/ReconciliationDetailData';
import { MobileView } from '@/mixins';
import card from '@/mixins/card';

export default {
  data: () => ({
    currentNote: '',
  }),
  mixins: [ReconciliationDetailData, MobileView, card],
  computed: {
    ...mapGetters({
      _client: 'account/getCurrentClient',
      _user: 'account/getCurrentUser',
      notes: 'reconciliationDetails/getNotes',
    }),
    cardClass() {
      if (this.showMobileView) {
        return 'overflow:hidden;';
      }
      return 'width:100%; overflow:hidden;';
    },
  },
  methods: {
    ...mapActions({
      _uploadNote: 'reconciliationDetails/uploadNote',
      _deleteNote: 'reconciliationDetails/deleteNote',
    }),
    addNote() {
      const newNote = {
        note: this.currentNote,
        screen_id: this.data.screen_id,
        session_id: this.data.uuid,
        created_by: this._user.name,
      };
      this.currentNote = '';
      this._uploadNote(newNote);
    },
    clearNote() {
      this.currentNote = '';
    },
    deleteNote(id) {
      this._deleteNote({ uuid: id, session_id: this.data.uuid });
    },
    saveNotes() {
      const screenCopy = { ...this.data.screen };
      delete screenCopy.group;
      this._uploadNote(screenCopy);
    },
  },
};
</script>

<style></style>
